import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { Heading, Container, Text } from "@chakra-ui/react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const InfoPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle} container>
      <SEO title="Betingelser" />
      <Container marginTop="20">
        <Heading size="xl" marginBottom="5">
          Leasing med lønnstrekk
        </Heading>

        <Text>
          Bedriften du jobber i leaser sykkelen og legger inn et lønnstrekk
          tilsvarende leasingkostnad pr mnd inkl mva. Leasingperiode 3 år.. Den
          ansatte er ansvarlig for vedlikehold og reparasjon utover årlig
          service. Den ansatte skal forsikre sykkelen. (Scushi tilbyr Bikefinder
          med forsikring) Bikefinder legges til sykkelpris og blir en del av
          månedsleien. Forsikringsdelen i Bikefinder pakken bestilles og betales
          av ansatt.
        </Text>
        <Text size="lg" marginTop="5">
          Den ansatte kan etter endt leasingperiode kjøpe ut sykkelen for beløp
          tilsvarende 3 måneders leie. Leverandøren tar kontakt med en enkelte
          leasing tager 4 mnd før leasingavtalen går ut for tilbud om utkjøp.
          Ved utkjøp underveis vil resterende av leasingperioden faktureres +
          utkjøp (3 mnd leie). Leasingavtalen vil bli mellom leasingselskapet
          (Grenke Bank AG Branch Norway) og selskapet den ansatte jobber for.
          Navnet til den enkelte ansatte i firmaet vil fremkomme på kontrakten.
          Leasing kontrakten signeres av den som har prokura i selskapet.
        </Text>

        <Heading marginTop="10" marginBottom="5" size="xl">
          Kjøp
        </Heading>

        <Text>
          Sykkel og utstyr faktureres fratrukket rabatt inkl mva . Ansatte står
          fritt til å forsikre sykkel, men tilbud om Bikefinder og forsikring
          gjelder også ved kjøp. Årlig service, totalt 3 servicer. (inkl.
          software oppdatering) Den ansatte er ansvarlig for vedlikehold og
          reparasjon utover årlig service.
        </Text>

        <Heading size="sm" marginTop="5" marginBottom="2">
          Garanti
        </Heading>

        <Text>
          Sykkel må følge beskrevet service og vedlikeholds regime for at
          garantier skal gjelde. Det er 5 års fabrikkgaranti på motor, batteri
          og elektronikk.
        </Text>
        <Text>
          Sykler kan bestilles fra nettbutikk med utlevering fra våre 2 butikker
          eller tilkjørt hos den respektive bedrift.
        </Text>
      </Container>
    </Layout>
  )
}

InfoPage.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}

export default InfoPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
